import gql from "graphql-tag";

const promotionQuery = gql`
  query PromotionQuery($countryCode: String!, $businessUnit: String!) {
    specialEvents(countryCode: $countryCode, businessUnit: $businessUnit) {
      name
      publishDate
      unpublishDate
      hero {
        variant
        layout
        config {
          title {
            label
            color
          }
          subtitle {
            label
            color
          }
          description {
            label
            color
          }
          primaryButton {
            label
            backgroundColor
            backgroundColorHover
            borderColor
            color
            animated
          }
          secondaryButton {
            label
            backgroundColor
            backgroundColorHover
            borderColor
            color
            animated
          }
          textureUrl
          backgroundUrl
          backgroundColor
          mainImageUrl
          simulatorStripeColor
          filters {
            selectors
          }
          hasAffiliate
          backgroundUrlSm
        }
      }
      banner {
        variant
        config {
          ... on IBanner {
            linkUrl
            linkText
          }
          ... on TextBannerConfig {
            backgroundColor
            content
            title
            imageUrl
          }
          ... on ImageBannerConfig {
            alt
            srcSmall
            srcLarge
          }
        }
      }
      card {
        config {
          name
          productIds
          flagUrl
        }
      }
    }
  }
`;

export { promotionQuery };
